import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useServices } from 'index';

export type DeleteClassesResult = {
  succeeded: number;
  failed: number;
  total: number;
};

export const useDeleteClasses = (organizationId: string) => {
  const classesService = useServices().classesService;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (classIds: string[]): Promise<DeleteClassesResult> => {
      const results = await Promise.allSettled(classIds.map((id) => classesService.deleteClassAndUpdate(id)));
      return {
        succeeded: results.filter((r) => r.status === 'fulfilled').length,
        failed: results.filter((r) => r.status === 'rejected').length,
        total: classIds.length,
      };
    },
    onSuccess: (_, classIds) => {
      queryClient.invalidateQueries({ queryKey: ['organizationClasses', organizationId] });
    },
  });
};
